import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, withStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';
import CancelIcon from '@material-ui/icons/Cancel';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { AutocompleteInput, Button, CREATE, DisabledInput, maxValue, minValue, number, NumberInput, ReferenceInput, refreshView, required, SaveButton, showNotification, SimpleForm, LongTextInput, withDataProvider } from 'react-admin';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { change, isSubmitting, submit } from 'redux-form';

const formName = "post-quick-transfer-member-points";

const styles = createStyles({
    button: {
        position: 'relative',
    },
    iconPaddingStyle: {
        marginRight: '0.5em',
    },
});

const differ = MemberID => value => value === MemberID ? `Cannot transfer points to the same member` : undefined;

class TransferPointsButton extends Component {
    state = {
        error: false,
        showDialog: false,
    };
    
    handleClick = () => {
        this.setState({ showDialog: true });
    };
    
    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleSaveClick = () => {
        const { submit } = this.props;

        // Trigger a submit of our custom quick create form
        // This is needed because our modal action buttons are oustide the form
        submit(formName);
    };

    handleSubmit = values => {
        const { change, dispatch, dataProvider, refreshView } = this.props;
        dataProvider(CREATE, `account-statements/transfer`, {
            data: values,
        })
            .then(() => {
                dispatch(change(formName, 'Receiver', null));
                dispatch(change(formName, 'Amount', 0));
                dispatch(change(formName, 'Description', null));
                dispatch(showNotification(`Points transfer succeed`));
                dispatch(refreshView());
            })
            .catch(e => {
                console.error(e);
                dispatch(change(formName, 'Receiver', null));
                dispatch(change(formName, 'Amount', 0));
                dispatch(change(formName, 'Description', null));
                dispatch(showNotification(`Error: Points transfer failed: ${e}`, `warning`));
                dispatch(refreshView());
            });
    };

    render() {
        const { showDialog } = this.state;
        const { isSubmitting, record, className, classes, change, dispatch, refreshView } = this.props;
        if (record.Status !== 'ACTIVE' || record.Point === 0) {
            return (<div />);
        }
        return (
            <Fragment>
                <Button
                    label="Trf Pts"
                    onClick={this.handleClick}
                >
                    <SendIcon />
                </Button>
                <Dialog
                    open={showDialog}
                    onClose={this.handleCloseClick}
                    aria-labelledby={`${formName}-${record.id}`}
                    fullWidth={true}
                    onExited={
                        () => {
                            dispatch(change(formName, 'Receiver', null));
                            dispatch(change(formName, 'Amount', 0));
                            dispatch(change(formName, 'Description', null));
                            dispatch(refreshView());
                        }
                    }
                >
                    <DialogTitle id={`${formName}-${record.id}`}>Transfer Points</DialogTitle>
                    <DialogContent>
                        <SimpleForm
                            form={formName}
                            resource="account-statements"
                            onSubmit={this.handleSubmit}
                            toolbar={null}
                            defaultValue={{
                                Sender: record.id,
                                AgentCode: record.AgentCode,
                                UserId: record.UserId,
                                Points: record.Point,
                                Amount: 0,
                                Source: 'TRANSFER',
                                Description: null,
                            }}
                        >
                            <DisabledInput
                                fullWidth
                                source="Sender"
                                label="Sender ID"
                                validate={[required()]}
                            />
                            <DisabledInput
                                fullWidth
                                source="AgentCode"
                                label="Agent Code"
                                validate={[required()]}
                            />
                            <DisabledInput
                                fullWidth
                                source="UserId"
                                label="User ID"
                                validate={[required()]}
                            />
                            <DisabledInput
                                fullWidth
                                source="Points"
                                label="Current Points"
                                validate={[required()]}
                            />
                            <ReferenceInput
                                source="Receiver"
                                reference="members"
                                validate={[required(), differ(record.id)]}
                            >
                                <AutocompleteInput
                                    optionText={
                                        choice => [choice.AgentCode, choice.UserId, choice.Name, choice.Email].join(' - ')
                                    }
                                    options={{
                                        suggestionsContainerProps: {
                                            style: {
                                                zIndex: 9999,
                                            },
                                        },
                                    }}
                                />
                            </ReferenceInput>
                            <NumberInput
                                fullWidth
                                source="Amount"
                                validate={[required(), number(), minValue(1), maxValue(record.Point)]}
                            />
                            <LongTextInput
                                fullWidth
                                source="Description"
                            />
                        </SimpleForm>
                    </DialogContent>
                    <DialogActions>
                        <SaveButton
                            saving={isSubmitting}
                            onClick={this.handleSaveClick}
                        />
                        <Button
                            size="large"
                            className={classnames(classes.button, className)}
                            variant="raised"
                            color="default"
                            label="Cancel"
                            onClick={this.handleCloseClick}
                        >
                            <CancelIcon
                                size={25}
                                thickness={2}
                                className={classes.iconPaddingStyle}
                            />
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

TransferPointsButton.propTypes = {
    dataProvider: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    isSubmitting: isSubmitting(formName)(state),
});

const mapDispatchToProps = {
    change,
    refreshView,
    showNotification,
    submit
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(styles),
    withDataProvider
);

export default enhance(TransferPointsButton);